import { Avatar, AvatarProps } from 'antd';
import { getInitials } from '../utils';
import { UserOutlined } from '@ant-design/icons';
import { getAvatarSource } from '@shared/utils/avatar.helper';
import { ComponentRef, forwardRef } from 'react';

export type AppAvatarProps = AvatarProps & {
  name?: string | null;
  phone?: string | null;
};

const COLORS = [
  'var(--color-blue-900)',
  'var(--color-emerald-900)',
  'var(--color-rose-900)',
  'var(--color-orange-900)',
  'var(--color-amber-900)',
  'var(--color-fuchsia-900)',
  'var(--color-teal-900)',
  'var(--color-violet-900)',
];

const getAvatarColor = (value?: string | null) => {
  if (!value) return COLORS[0];

  let hash = 0;

  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }

  // return COLORS[Math.abs(hash) % COLORS.length];
  // return 'var(--color-gray-900)';
  return 'linear-gradient(90deg, var(--color-primary-300), var(--color-primary-600))';
};

export const AppAvatar = forwardRef<ComponentRef<typeof Avatar>, AppAvatarProps>(function AppAvatar(
  { name, phone, src, ...rest },
  ref
) {
  const flag = phone ? getAvatarSource({ phoneNumber: phone }) : undefined;
  const avatarSrc = src || flag;

  const initials = getInitials(name || phone);
  const icon = !src && !initials ? <UserOutlined /> : undefined;

  return (
    <Avatar
      ref={ref}
      src={avatarSrc}
      icon={icon}
      {...rest}
      style={{
        border: '1px solid var(--color-gray-500)',
        // backgroundColor: avatarSrc ? undefined : getAvatarColor(name || phone || ''),
        background: avatarSrc ? undefined : getAvatarColor(name || phone || ''),
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* <span className="text-sm">{!avatarSrc && initials?.charAt(0)}</span> */}
      <span className="text-sm">
        {!avatarSrc && initials?.charAt(0)}
        {!avatarSrc && initials?.charAt(1)}
      </span>
    </Avatar>
  );
});
